import React from 'react'
import { Box, Breakpoint, styled } from '@mui/material'

export const Row = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
}))

export const Column = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}))

export const SwapRow = styled(Box)<{size: Breakpoint}>(({ theme, size }) => ({
  display: 'flex',
  flexDirection: 'row',
  [theme.breakpoints.down(size)]: {
    flexDirection: 'column',
  },
}))

export const SwapColumn = styled(Box)<{size: Breakpoint}>(({ theme, size }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down(size)]: {
    flexDirection: 'row',
  },
}))